'use client'

import { BlankFillingQuestion } from '@entities/lesson'
import React from 'react'

import { Box, HStack, Typography } from '@podo-app/design-system-temp'

type Props = {
  question: BlankFillingQuestion
}

export const BlankFillingHintFunnel = ({ question }: Props) => {
  return (
    <HStack className="gap-2 flex-wrap items-center">
      {question.source.hint.map((hint, index, origin) => (
        <React.Fragment key={hint}>
          <Typography size="h3" className="font-medium">
            {hint}
          </Typography>
          {index !== origin.length - 1 && <Box className="w-px h-2 border" />}
        </React.Fragment>
      ))}
    </HStack>
  )
}
